import { ActionTypes } from 'src/types/types';

export const FEATURE_NAME = 'attendeeEventsSidebar';
export const actionTypes = {} satisfies ActionTypes<typeof FEATURE_NAME>;
